import Vue from 'vue'
import axios from 'axios'
import store from '@/store'
import { ACCESS_TOKEN, LANGUAGE } from '@/store/variables'
import { Toast, Dialog } from 'vant'

import config from '@/config'

const service = axios.create({
  baseURL: config.global.domainUrl,
  timeout: config.global.http.timeout
})

service.postAction = function (url, params) {
  return this({
    url: url,
    method: 'post',
    data: params
  })
}

service.putAction = function (url, params) {
  return this({
    url: url,
    method: 'put',
    data: params
  })
}

service.deleteAction = function (url, params) {
  return this({
    url: url,
    method: 'delete',
    params: params
  })
}

service.getAction = function (url, params) {
  return this({
    url: url,
    method: 'get',
    params: params
  })
}

service.downFile = function (url, parameter) {
  return this({
    url: url,
    params: parameter,
    method: 'get',
    responseType: 'blob'
  })
}

const err = function (error) {
  if (error.response) {
    const data = error.response.data
    const token = Vue.ls.get(ACCESS_TOKEN)
    console.log('------异常响应------', token)
    console.log('------异常响应------', error.response.status)
    switch (error.response.status) {
      case 403:
        Toast.fail({
          message: '拒绝访问', duration: 1500
        })
        break
      case 500:
        if (token && data.msg === '认证失效,请重新登陆') {
          Dialog.alert({
            title: '登录已过期',
            message: '登录已过期，请重新登录',
            confirmButtonText: '重新登录'
          }).then(() => {
            store.dispatch('Logout').then(function () {
              Vue.ls.remove(ACCESS_TOKEN)
              window.location.reload()
            })
          })
        } else {
          Toast.fail({
            message: '服务异常，请稍后再试！', duration: 1500
          })
        }
        break
      case 404:
        Toast.fail({
          message: '资源未找到！', duration: 1500
        })
        break
      case 504:
        Toast.fail({
          message: '网络超时', duration: 1500
        })
        break
      case 401:
        Toast.fail({
          message: '未授权，请重新登录', duration: 1500
        })
        if (token) {
          store.dispatch('Logout').then(function () {
            Vue.ls.remove(ACCESS_TOKEN)
            window.location.reload()
          })
          //
          // Vue.ls.remove(ACCESS_TOKEN)
          // setTimeout(function () {
          //   window.location.reload()
          // }, 1500)
        }
        break
      default:
        Toast.fail({
          message: data.msg, duration: 1500
        })
        break
    }
  }
  return Promise.reject(error)
}

service.interceptors.request.use(config => {
  const token = Vue.ls.get(ACCESS_TOKEN)
  if (token) {
    config.headers.token = token
    // config.headers['X-Access-Token'] = token
  }
  const language = Vue.ls.get(LANGUAGE)
  if (language) {
    config.params = {
      language: language,
      ...config.params
    }
  }
  if (config.method === 'get') {
    config.params = {
      _t: Date.parse(new Date()) / 1000,
      ...config.params
    }
  }
  return config
}, (error) => {
  return Promise.reject(error)
})

service.interceptors.response.use((response) => {
  return response.data
}, err)

const installer = {
  vm: {},
  install (Vue, router = {}) {
    if (this.installed) {
      return
    }
    this.installed = true

    if (!service) {
      console.error('You have to install axios')
      return
    }
    Object.defineProperties(Vue.prototype, {
      $http: {
        get: function get () {
          return service
        }
      }
    })
  }
}

export {
  installer as VueAxios,
  service as axios
}
